import apiClient from "../../apiClient";
import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { baseURL } from "../../ApiConstant";

// create Accessory
export const fsAccessoryCreate = async (
  fs_data_id: number,
  category: string,
  accessory_name_id: number,
  accessory_sub_name_id: number | null,
  number: number,
  reference: string | null,
  link: string | null,
  image_path: File | null,
  file_list: File[] | null
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const formData = new FormData();
    formData.append("fs_data_id", String(fs_data_id));
    formData.append("category", category);
    formData.append("accessory_name_id", String(accessory_name_id));
    formData.append("number", String(number));

    if (accessory_sub_name_id !== null) {
      formData.append("accessory_sub_name_id", String(accessory_sub_name_id));
    }

    if (reference !== null) {
      formData.append("reference", reference);
    }

    if (link !== null) {
      formData.append("link", link);
    }

    if (image_path !== null) {
      formData.append("image_path", image_path);
    }

    if (file_list !== null) {
      file_list.forEach((file, index) => {
        formData.append("file_list[]", file);
      });
    }

    const response = await fetch(`${baseURL}/api/fs-paint-accessory/create`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: formData,
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update Accessory
export const fsAccessoryUpdate = async (
  id: number,
  category: string,
  accessory_name_id: number,
  accessory_sub_name_id: number | null,
  number: number,
  reference: string | null,
  link: string | null,
  image_path: File | null,
  file_list: File[] | null
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const formData = new FormData();

    formData.append("category", category);
    formData.append("accessory_name_id", String(accessory_name_id));
    formData.append("number", String(number));

    if (accessory_sub_name_id !== null) {
      formData.append("accessory_sub_name_id", String(accessory_sub_name_id));
    }

    if (reference !== null) {
      formData.append("reference", reference);
    }

    if (link !== null) {
      formData.append("link", link);
    }

    if (image_path !== null) {
      formData.append("image_path", image_path);
    }

    if (file_list !== null) {
      file_list.forEach((file, index) => {
        formData.append("file_list[]", file);
      });
    }

    const response = await fetch(`${baseURL}/api/fs-paint-accessory/update/${id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: formData,
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Delete accessory
export const fsAccessoryDelete = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/fs-paint-accessory/delete/${id}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Delete  single file
export const fsAccessoryFileDelete = async (
  paint_accessory_data_id: number,
  index: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/fs-paint-accessory-file/delete`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ paint_accessory_data_id, index }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};